export type PlanColumnKey = "free" | "privilege" | "standard" | "executive";

export type PlanColumn = {
  key: PlanColumnKey;
  label: string;
};

export type PlanTableRow = {
  feature: string;
  description?: string;
  values: Record<PlanColumnKey, string>;
};

export type PlanPrice = {
  key: "free" | "standard" | "executive";
  name: string;
  priceLabel: string;
  description: string;
};

export const PLAN_COLUMNS: PlanColumn[] = [
  { key: "free", label: "フリープラン" },
  { key: "privilege", label: "特典コード" },
  { key: "standard", label: "スタンダードプラン" },
  { key: "executive", label: "エグゼクティブプラン" },
];

export const PLAN_PRICES: PlanPrice[] = [
  {
    key: "free",
    name: "フリープラン",
    priceLabel: "無料",
    description: "まずはWizMateの雰囲気を試したい方へ",
  },
  {
    key: "standard",
    name: "スタンダードプラン",
    priceLabel: "月額3,300円（税込）",
    description: "日々の相談・壁打ち・情報収集に使いたい方へ",
  },
  {
    key: "executive",
    name: "エグゼクティブプラン",
    priceLabel: "月額11,000円（税込）",
    description: "壁打ち・企業調査・定期配信をしっかり使い込みたい方へ",
  },
];

export const PLAN_LIMIT_ROWS: PlanTableRow[] = [
  {
    feature: "通常チャット",
    values: { free: "50回/月", privilege: "100回/30日", standard: "500回/月", executive: "実質無制限 ※" },
  },
  {
    feature: "AI壁打ちルーム",
    values: { free: "10ターン/月", privilege: "30ターン/30日", standard: "200ターン/月", executive: "1,000ターン/月" },
  },
  {
    feature: "企業リサーチ",
    values: { free: "3社/月", privilege: "3社/30日", standard: "10社/月", executive: "30社/月" },
  },
  {
    feature: "企業リサーチ深掘り",
    values: { free: "0回/月", privilege: "3回/30日", standard: "20回/月", executive: "120回/月" },
  },
  {
    feature: "ニュース通常配信",
    values: { free: "3回/月", privilege: "5回/30日", standard: "10回/月", executive: "実質無制限 ※" },
  },
  {
    feature: "ニュース定期配信",
    values: { free: "なし", privilege: "1枠", standard: "3枠", executive: "10枠" },
  },
  {
    feature: "レポート通常配信",
    values: { free: "1回/月", privilege: "3回/30日", standard: "10回/月", executive: "実質無制限 ※" },
  },
  {
    feature: "レポート定期配信",
    values: { free: "なし", privilege: "なし", standard: "3枠", executive: "10枠" },
  },
  {
    feature: "領収書整理",
    values: { free: "なし", privilege: "なし", standard: "100枚/月", executive: "実質無制限 ※" },
  },
  {
    feature: "社長メモ",
    values: { free: "なし", privilege: "なし", standard: "50枚/月", executive: "200枚/月" },
  },
  {
    feature: "カレンダー連携",
    description: "Googleカレンダーの予定確認に対応。予定の作成・変更・削除、自動調整は行いません。",
    values: { free: "あり", privilege: "あり", standard: "あり", executive: "あり" },
  },
];

export const PLAN_FREQUENCY_ROWS: PlanTableRow[] = [
  {
    feature: "ニュース定期配信",
    values: { free: "なし", privilege: "毎週 / 毎月", standard: "毎日 / 毎週 / 毎月", executive: "毎日 / 毎週 / 毎月" },
  },
  {
    feature: "レポート定期配信",
    values: { free: "なし", privilege: "なし", standard: "毎週 / 毎月", executive: "毎日 / 毎週 / 毎月" },
  },
];

export const PLAN_UNLIMITED_NOTE =
  "実質無制限と表示される機能についても、通常利用の範囲を超える短時間の連続実行、過度な高負荷利用、システム運営に支障を及ぼす利用、その他当社が不適切と判断する利用については、一時的な制限または利用停止を行う場合があります。";
